<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../../../component/common/Value/ArraySlotView.svelte";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import {SpaceUserTable} from "../../../../../lib/Table/SpaceUserTable";
    import SpaceCompanyDepartmentEditDialogView from "./SpaceCompanyDepartmentEditDialogView.svelte";
    import SpaceCompanyDepartmentRowView from "./SpaceCompanyDepartmentRowView.svelte";

    export let space;
    let isLoading = false;

    let spaceCompanyDepartments = null;

    let editData = null;

    onMount(() => {
        loadData();
    });

    function loadData() {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        paramMap['setup_created_updated_user_name'] = undefined;
        const url = UrlUtil.createApiUrl("space_company_department", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;

            console.log(response);
            const body = response['body'];
            spaceCompanyDepartments = body['space_company_departments'];


        });
    }

    function onAdd() {
        editData = {
            space_id: space.id,
            authority_type: SpaceUserTable.AuthorityType.Editable,
        };
    }

    function onEdit(event) {
        const spaceCompanyDepartment = event.detail.spaceCompanyDepartment;
        editData = {...spaceCompanyDepartment};
    }


</script>


<div class="space-company-department-view">

    <LoadingContentView isLoading={isLoading}>
        <div class="add-button-area">
            <button on:click={onAdd}>
                <FontAwesomeView icon="plus"/>
                会社/部署を追加
            </button>
        </div>
        <div class="table-area">
            <ArraySlotView array={spaceCompanyDepartments}>
                <table class="space-company-department-table">
                    <thead>
                    <tr>
                        <th></th>
                        <th class="company-name">会社名</th>
                        <th class="department-name">部署名</th>
                        <th>権限</th>
                        <th>作成更新情報</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>
                    {#each spaceCompanyDepartments as spaceCompanyDepartment}
                        <SpaceCompanyDepartmentRowView
                                space={space}
                                spaceCompanyDepartment={spaceCompanyDepartment}
                                on:edit={onEdit}
                                on:update={loadData}
                        />

                    {/each}
                    </tbody>
                </table>

            </ArraySlotView>

        </div>
    </LoadingContentView>

    <SpaceCompanyDepartmentEditDialogView
            editData={editData}
            on:close={()=>{
                editData = null;
            }}
            on:update={()=>{
                loadData();
            }}
    />

</div>
<style lang="scss">
    .space-company-department-view {
        padding: 24px;


        .add-button-area {
            text-align: right;
            font-size: 0.75em;
        }

        .table-area {
            margin-top: 24px;

            .space-company-department-table {
                width: 100%;

                thead {
                    tr {
                        th {
                            &.company-name {
                                min-width: 300px;
                            }

                            &.department-name {
                                min-width: 300px;
                            }
                        }
                    }
                }
            }

        }


    }
</style>